import {getFinanceEnvironment} from '../utils';

export default class SearchBar {
    constructor() {
        this.onboardingForm = document.querySelector('.teaser-form');
        this.init();
    }

    static get ONBOARDING_API_URL() {
        return `${getFinanceEnvironment(window.location.hostname)}/cc/onboarding/api/profiles/exists`;
    }

    init() {
        if (!this.onboardingForm) {
            return false;
        }
        this.setupEventListeners();
    }

    setupEventListeners() {
        this.onboardingForm.addEventListener('submit', this.handleSubmit.bind(this));
    }

    handleSubmit(event) {
        event.preventDefault();
        const formData = new FormData(this.onboardingForm);
        const withOnboarding = formData.get('withOnboarding');
        if (withOnboarding === 'true') {
            this.checkUserOnboarding().then((exists) => {
                if (exists) {
                    this.onboardingForm.submit();
                } else {
                    window.location.href = `${getFinanceEnvironment(window.location.hostname)}/cc/onboarding/angaben`;
                }
            });
        } else {
            this.onboardingForm.submit();
        }
    }

    checkUserOnboarding() {
        return fetch(SearchBar.ONBOARDING_API_URL, {
            credentials: 'include'
        })
            .then(response => response.json())
            .then(response => response.exists)
            .catch((error) => {
                console.error(error);
                return true;
            });
    }
}
